import { Menu, MenuItem, MenuList, styled, SxProps, TextField, Toolbar, useTheme } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts, themeSettings } from "../../../../configuration/themeSettings";
import GoToPage from "../../../GoToPage/GoToPage";
import { BorderBottom, BorderRight } from "@mui/icons-material";


export const ToolbarStyled = styled(Toolbar, { label: "ToolbarStyled" })
    (({ theme }) => ({
        height: 55,
        minHeight: "auto !important",
        paddingLeft: 16 + "px !important",
        paddingRight: 16 + "px !important",
        backgroundColor: '#fff',
        width: "100%",
        position: 'sticky',
        zIndex: 1,
        top: 0,
    }));

export const SearchSites = styled(TextField, { label: "search_bar-sites" })
    (({ theme }) => ({
        width: "100%",
    }))

export const Li = styled(MenuItem, { label: "search_bar-list-li" })
    (({ theme }) => ({
        borderBottom: '1px solid ' + StyleguideSavioColors.lighterGrey,
        "&:hover": {
            backgroundColor: MiscSavio.hoverBackgroundTable,
        }
    }))


export const MenuStyled = styled(Menu, { label: "search_bar-menu-styled" })
    (({ theme }) => ({

        "> .MuiPopover-paper": {
            height: 400,
            borderBottomRightRadius: '4px !important',
            borderBottomLeftRadius: '4px !important',
            "> ul": {
                width: "400px !important",
                position: 'relative',
                "li": {
                    "div": {
                        textTransform: 'uppercase',
                        width: "100%",
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',

                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                    }

                }

            }
        }
    }))

export const LinkCustom = styled(GoToPage, { label: "search_bar-list-a" })
    (({ theme }) => ({
        display: 'block',
        width: '100%',
        color: StyleguideSavioColors.text.black + " !important",

        "&:hover": {
            //textDecoration: "underline !important",
            backgroundColor: "unset",
            //color: MiscSavio.hoverColor + " !important",
        }
    }))

    export const MenuListCustom = styled(MenuList, { label: "search_bar-MenuListCustom" })
    (({ theme }) => ({
        
        "> li.selected":{
            backgroundColor: MiscSavio.hoverBackgroundTable, 
            "svg":{
                position: 'absolute',
                fontSize: 17,
                left: 8,
            },
            "*":{
                color: '#fff',
            }
        },
        "> li":{
            paddingLeft: 32,

            "a":{
                textDecoration: 'none',
            },

            "&:not(.selected)":{
                "&:hover":{
                    backgroundColor: 'inherit',
                    
                    "*":{textDecoration: 'underline',color: StyleguideSavioColors.blue,},
                    "&:before":{
                        display: 'block',
                        content: "''",
                        width: 3,
                        height: '100%',
                        backgroundColor: StyleguideSavioColors.blue ,
                        left:0,
                        position:'absolute',
                    }
                }
            }
        }
       
    }))

export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        siteSelectorButton: {
            fontSize: 12,
            fontWeight: StyleguideSavioFonts.medium,
            //marginLeft: theme.spacing(2),
            textAlign: "left",
            lineHeight: '14px',

            "> span:not(.MuiButton-icon)": {
                width: "100%",
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                justifyContent: "flex-start",
            },

            ".MuiButton-startIcon": {
                marginRight: 0,
            },

            "svg": {
                fontSize: "27px !important",
            }
        } as SxProps,
        list: {
            marginTop: 1.2,
            ".MuiList-root": {
                paddingTop: 0,
                paddingBottom: 0,

                ".MuiMenuItem-root": {
                    fontSize: 12,

                }
            }
        }
    };
    return classes;
};